/**
 * 正则校验
 */
export const regexpNumber = (string) => {
  const reg = new RegExp(/^[0-9]*$/);
  return reg.test(string);
};

export const regexpString = (string) => {
  const reg = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^[a-zA-Z0-9\、\,\，\.\。\‘\’\“\”\：\:\；\;\#\*\（\）\(\)\+\_\-\[\]\《\》\【\】\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u00B7]*$/,
  );
  return reg.test(string);
};

export const regexpName = (string) => {
  const reg = new RegExp(
    /^[a-zA-Z0-9\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u00B7]*$/,
  );
  return reg.test(string);
};

export const regexpCode = (string) => {
  const reg = new RegExp(/^[a-zA-Z0-9]*$/);
  return reg.test(string);
};

export const regexpEmail = (string) => {
  const reg = new RegExp(/^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/);
  return reg.test(string);
};

export const regexpMobilePhone = (string) => {
  const reg = new RegExp(/^1\d{10}$/);
  return reg.test(string);
};
